module.exports = __webpack_public_path__ + "static/media/small_screen.a0649187.gif";